export const SUCCESS_MESSAGES = {
  REQUEST_PASSWORD:
    'Reset password email will be sent shortly, if there is a valid account for that email address.',
  NEED_HELP:
    'Support request email will be sent shortly, if there is a valid non-locked account for that email address.'
}
